import { createScope } from "bunshi"
import type { LoggerApi } from "./logger-scope-provider"

export const LoggerScope = createScope<LoggerApi>(undefined)
